export default {
  props: ["icon", "title", "link", "linkList"],
  data() {
    return {
      classes: ["menu-item"],
      active: false,
    };
  },
  created() {
    this.active = this.urlHasLink(window.location.href);
  },
  methods: {
    goTo(link, e) {
      e.preventDefault();

      //wipe any transition data
      this.setTransferMode(false);

      //check if active
      this.active = this.urlHasLink();

      //remove uploading item if not to upload menu item
      if (!link.includes("upload")) {
        this.$store.state.isUploadingMobile = false;
      }

      this.$router.push(link);
    },
    setTransferMode(setting) {
      this.$store.state.isTransfering = setting;

      if (!setting) {
        //wipe data if not transfering anymore
        this.$store.state.transferItems = {
          selectedFiles: [],
          selectedFolders: [],
          collection: {},
        };
      }
    },
    urlHasLink() {
      const url = window.location.href;

      return (
        this.linkList.find((linkPart) => {
          if (url.includes(linkPart)) {
            return true;
          }
        }) !== undefined || url.includes(this.link)
      );
    },
  },
  watch: {
    $route() {
      this.active = this.urlHasLink();
    },
  },
};
